import { render, staticRenderFns } from "./BackCoverFSGPromoArea.vue?vue&type=template&id=5d816015&"
import script from "./BackCoverFSGPromoArea.vue?vue&type=script&lang=js&"
export * from "./BackCoverFSGPromoArea.vue?vue&type=script&lang=js&"
import style0 from "./BackCoverFSGPromoArea.vue?vue&type=style&index=0&id=5d816015&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports